module.exports = __webpack_public_path__ + "static/media/G1-11-Cloey-Harris-cod31.e7532459.png";